export const checkUndefinedShow_NA = (value) => {

    if(!value && value === ""){
        return "NA";
    }else{
        return value;
    }

}

export const rcCopyLabelCheck = (value) => {

    if(value === "no"){
        return "No RC copy";
    }else if(value === "yes"){
        return "Available RC copy";
    }else{
        return "NA";
    }

}